import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ClipboardService } from "@merri/common";
import { Subject, takeUntil } from "rxjs";
import { SeoService, SessionService, SessionUser, SnackBarService } from "src/app/core";

@Component({
    selector: "app-shadow-widget-url-popup",
    templateUrl: "./shadow-widget-url-popup.component.html",
    styleUrls: ["./shadow-widget-url-popup.component.scss"],
    standalone: false
})
export class ShadowWidgetUrlPopupComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<void> = new Subject<void>();

  url: string;
  title: string;

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private clipboardService: ClipboardService,
    private snackBarService: SnackBarService,
    private seoService: SeoService,
  ) {}

  ngOnInit(): void {
    this.sessionService.sessionUser$.pipe(takeUntil(this._destroy$)).subscribe(user => {
      this.url = this.buildUrl(user);
      this.title = this.seoService.getTitle() ?? "Shareable Shadow Link";
    });
  }

  buildUrl(user: SessionUser): string {
    return this.sessionService.getAbsoluteShadowLoginUrl(user.authUserId, this.router.url);
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  block($event: MouseEvent): void {
    $event.stopPropagation();
  }

  onCopyClick($event: MouseEvent): void {
    $event.stopPropagation();

    this.clipboardService.copyToClipboard(this.url);
    this.snackBarService.show({ message: "Shareable link copied to clipboard", action: "Hide", duration: 3000 });
  }
}
